import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useConfig } from "src/hooks/config";
import Money from "src/common/components/money";
import { getBetCalculations } from "calculation";
import { useTranslation } from "src/hooks/translation";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations";
import upperDataStore from "src/stores/upperData";

interface IProps {
	stake: number;
}

const BetDetailsTaxOnStake = ({ stake }: IProps) => {
	const t = useTranslation();
	const config = useConfig();
	const { partnerConfig, currencyConfig } = useRecoilValue(upperDataStore);

	const { taxedStake } = useMemo(
		() =>
			getBetCalculations([BetCalculationsEnum.TaxOnStake], {
				config,
				partnerConfig,
				stake: +stake,
				currencyConfig,
			}),
		[config, stake, currencyConfig, partnerConfig]
	);

	if (!taxedStake || !config.taxPercentOnStake) return null;

	return (
		<div className="B-betslip-bet-details-info-row">
			<p className="B-info-row-title">
				{t("Tax on stake")}:<span className="B-percent">{config.taxPercentOnStake}%</span>
			</p>

			<p className="B-info-row-number">
				<Money amount={+stake - taxedStake} />
			</p>
		</div>
	);
};

export default BetDetailsTaxOnStake;
